export default function SwitchBanksDialogController(
  $rootScope,
  $location,
  $route,
  $filter,

  alerts,
  loaderService,
  ssDialogService,
  orgDataService,
  userService,
  authorizationService
) {
  const vm = this;

  vm.allBanksFiltered = false;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleSwitchClick = _handleSwitchClick;

  vm.handleFilterTextChange = handleFilterTextChange;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialogClick() {
    _closeDialog();
  }


  function handleFilterTextChange(newText) {
    vm.allBanksFiltered = $filter('filter')(vm.assignedBanks, { customerName: newText }).length === 0;
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
  }

  function _handleSwitchClick(bank) {
    const { customerId, displayName } = bank;
    loaderService.showViewLoader = true;
    orgDataService.switchBanks(customerId).then((switchBanksResponse) => {
      if (switchBanksResponse.status === 200) {
        const token = {
          userName: userService.user.loginName,
          access_token: switchBanksResponse.data.access_token,
          access_token_expires_in: switchBanksResponse.data.access_token_expires_in,
          expires_in: switchBanksResponse.data.expires_in,
        };
        authorizationService.setToken(token);
        userService.refreshUser()
          .then(() => {
            $rootScope.$broadcast('loggedIn');
            loaderService.showViewLoader = false;
            alerts.success(`You have successfully switched to "${displayName}".`);
            _closeDialog();
            if ($location.$$path === '/home') {
              $route.reload();
            }
            $location.path('/home');
          });
      }
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.home.switchBanksDialog);
  }
}

SwitchBanksDialogController.$inject = [
  '$rootScope',
  '$location',
  '$route',
  '$filter',

  'alerts',
  'loaderService',
  'ssDialogService',
  'orgDataService',
  'userService',
  'authorizationService',
];
